import { useEffect, useState } from "react";
import * as api from '../../api/index.js';
import { Button, Form, Modal, Alert, InputGroup } from 'react-bootstrap';
import axios from "axios";
import ColorInput from "../Form/ColorInput.js";
import TrailsMap from './../Trails/TrailsMap';
import Trail from "../Trails/Trail.js";

export default function TrailDialog({ mode, trail, trailName, showDialog, setShowDialog, refresh }) {
    const [color, setColor] = useState("");
    const [coordinates, setCoordinates] = useState([]);
    const [submitError, setSubmitError] = useState(null);

    useEffect(() => {
        if (showDialog) {
            setColor(trail?.color ?? "");
            setCoordinates(trail?.path.coordinates ?? []);
            setSubmitError(null);
        }
    }, [showDialog]);

    function editCoordinates(index, type, value) {
        if (index === coordinates.length) {
            coordinates.push(type === 0 ? [value, ""] : ["", value]);
        } else {
            coordinates[index][type] = value;
        }

        while (coordinates.at(-1)?.every(c => !c) ?? false) {
            coordinates.pop();
        }

        setCoordinates([...coordinates]);
    }

    async function onSubmit() {
        if (mode === "edit") {
            await api.updateTrail(trail._id, { color, path: { type: "LineString", coordinates } });
        } else try {
            await api.createTrail({ name: trailName, color, path: { type: "LineString", coordinates } });
        } catch (error) {
            if (axios.isAxiosError(error)) {
                setSubmitError({
                    "server": "An unexpected error occurred.",
                    "duplicate-field-name": "A trail with this name already exists.",
                    "invalid-name": "Invalid trail name.",
                    "invalid-color": "Invalid trail color.",
                    "invalid-coordinates": "Must have at least 2 pairs of coordinates in trail.",
                    "invalid-path": "Invalid trail path. Please make sure your coordinates are correct."
                }[error.response.data.errorType]);
            } else {
                setSubmitError("An unexpected error occurred.");
            }

            return;
        }

        setShowDialog(false);
        refresh();
    }

    return (
        <Modal show={showDialog} onHide={() => setShowDialog(false)}>
            <Modal.Header closeButton>
                <Modal.Title>{mode === "edit" ? "Edit" : "Create"} Trail '{trail?.name ?? trailName}'</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form.Group className="mb-3">
                    <ColorInput value={color} onChange={e => setColor(e.target.value)} />
                    <Form.Control.Feedback type="invalid">
                        Please enter a trail color.
                    </Form.Control.Feedback>
                </Form.Group>
                <h1 id="trail-coordinates-title">Trail Coordinates</h1>
                <Form.Group className="mb-3 overflow-y-auto" style={{ maxHeight: "19rem" }}>
                    {[...coordinates, ["", ""]].map((position, i) => (
                        <InputGroup key={i}>
                            <Form.Control type="number" placeholder="Latitude" aria-label="Latitude Input" value={position[0]} onChange={e => editCoordinates(i, 0, e.target.value)} />
                            <Form.Control type="number" placeholder="Longitude" aria-label="Longitude Input" value={position[1]} onChange={e => editCoordinates(i, 1, e.target.value)} />
                        </InputGroup>
                    ))}
                </Form.Group>
                <TrailsMap showTrails={false}>
                    <Trail key={Math.random()} color={color} control={false} name={trail?.name ?? trailName} positions={coordinates.map(pair => ({ lat: pair[1], lng: pair[0] }))} />
                </TrailsMap>
                {submitError && <Alert className="mt-3" variant="danger">{submitError}</Alert>}
            </Modal.Body>
            <Modal.Footer style={{ display: 'flex', justifyContent: 'center', gap: '20px' }}>
                <Button variant="danger" className="modal-action-btn" onClick={() => setShowDialog(false)}>Cancel</Button>
                <Button variant="primary" className="modal-action-btn" onClick={onSubmit}>{mode === "edit" ? "Save" : "Create"}</Button>
            </Modal.Footer>
        </Modal>
    );
}